import { ofType } from 'redux-observable';
import { debounceTime, switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { REQUEST_COMPANY_NAMES, EPIC_ERROR } from 'Constants/redux';
import { saveAuthToken } from 'Api';
import service from 'Api/service';
import { receiveCompanyNames } from 'Actions';

const fetchCompanyNamesEpic = (action$) =>
  action$.pipe(
    ofType(REQUEST_COMPANY_NAMES),
    debounceTime(500),
    switchMap((action) => {
      const { numberPer: per, query, page, categories } = action.filter;
      return from(
        service.get(`${import.meta.env.VITE_API_DOMAIN}/api/companies/names`, {
          per,
          query,
          page,
          categories,
        })
      ).pipe(
        map((response) => {
          saveAuthToken(response.headers);
          return receiveCompanyNames(response);
        }),
        catchError((error) => {
          console.error('fetchCompanyNamesEpic error', error);
          return of({ type: EPIC_ERROR });
        })
      );
    })
  );

export default fetchCompanyNamesEpic;
